import styled from 'styled-components';

export const PageWrapper = styled.div`
    /* padding: 20px; */
`;

export const ControlsRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 24px;
    margin-top: 16px;
`;

export const TabsContainer = styled.div`
    display: inline-flex;
    background: #e9ecef;
    border-radius: 12px;
    padding: 4px;
    align-items: center;
`;

export const ContentContainer = styled.div`
    width: 100%;
`;

export const TabButton = styled.button<{ active: boolean }>`
    border: none;
    padding: 10px 24px;
    border-radius: 10px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    background: ${({ active }) => (active ? '#ffffff' : 'transparent')};
    color: ${({ active }) => (active ? '#111827' : '#6b7280')};
    box-shadow: ${({ active }) =>
        active ? '0 1px 3px rgba(0,0,0,0.08)' : 'none'};
`;

export const Label = styled.label`
    font-size: 16px;
    font-weight: 500;
`;

export const Select = styled.select`
    padding: 10px 14px;
    font-size: 16px;
    border-radius: 8px;
    border: 1px solid #cbd5e1;
    min-width: 240px;
`;

export const IframeWrapper = styled.div`
    margin-top: 24px;
    height: 75vh;
`;

export const Loader = styled.div`
    margin-top: 32px;
    font-size: 18px;
`;
